export default __webpack_public_path__ + "static/media/twitter.bef3f344.svg";